import { render } from "./FolderUnitList.vue?vue&type=template&id=50fa3272"
import script from "./FolderUnitList.vue?vue&type=script&lang=js"
export * from "./FolderUnitList.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__